/* THELAURENMATOS — product photo viewer + variant handling */
(function () {
  "use strict";

  /* ---------------- PHOTO VIEWER ---------------- */
  var gallery = document.querySelector("[data-gallery]");
  if (gallery) {
    var main = gallery.querySelector("[data-main]");
    var counter = gallery.querySelector("[data-counter]");
    var thumbs = [].slice.call(gallery.querySelectorAll("[data-thumb]"));
    var sources = [];
    try {
      sources = JSON.parse(gallery.getAttribute("data-photos") || "[]");
    } catch (e) { sources = []; }

    var index = 0;

    function paint(i) {
      if (!sources.length) return;
      var n = sources.length;
      index = ((i % n) + n) % n;
      var img = main.querySelector("img");
      if (img) {
        img.src = sources[index].big;
        img.srcset = "";
        img.alt = sources[index].alt || "";
      }
      if (counter) counter.textContent = (index + 1) + " / " + n;
      thumbs.forEach(function (t, ti) {
        var on = ti === index;
        t.setAttribute("aria-current", String(on));
        if (on && t.scrollIntoView) t.scrollIntoView({ block: "nearest", inline: "nearest" });
      });
    }

    thumbs.forEach(function (t, ti) {
      t.addEventListener("click", function () { paint(ti); });
    });

    var prev = gallery.querySelector("[data-prev]");
    var next = gallery.querySelector("[data-next]");
    if (prev) prev.addEventListener("click", function () { paint(index - 1); });
    if (next) next.addEventListener("click", function () { paint(index + 1); });

    if (sources.length > 1) {
      document.addEventListener("keydown", function (e) {
        if (e.key === "ArrowLeft") { e.preventDefault(); paint(index - 1); }
        else if (e.key === "ArrowRight") { e.preventDefault(); paint(index + 1); }
      });

      var x0 = null;
      main.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener("touchend", function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) paint(index + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });
    }
  }

  /* ---------------- VARIANT PICKER ---------------- */
  var picker = document.querySelector("[data-variant-picker]");
  if (picker) {
    // Queried from the document rather than the form, so this keeps working
    // regardless of how Shopify renders the {% form %} wrapper.
    var idField = document.querySelector("[data-variant-id]");
    var priceEl = document.querySelector("[data-price]");
    var addBtn = document.querySelector("[data-add]");
    var variants = [];
    try {
      variants = JSON.parse(picker.getAttribute("data-variants") || "[]");
    } catch (e) { variants = []; }

    picker.addEventListener("change", function () {
      var id = picker.value;
      if (idField) idField.value = id;
      var v = null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) { v = variants[i]; break; }
      }
      if (!v) return;
      if (priceEl) priceEl.innerHTML = v.price_html || priceEl.innerHTML;
      if (addBtn) {
        if (v.available) {
          addBtn.removeAttribute("disabled");
          addBtn.textContent = "ADD TO BAG";
        } else {
          addBtn.setAttribute("disabled", "disabled");
          addBtn.textContent = "SOLD";
        }
      }
    });
  }

  /* ---------------- CART QUANTITY ---------------- */
  // Submit the cart form when a quantity changes, so there is no separate
  // "update" step to forget.
  var cartForm = document.querySelector("[data-cart-form]");
  if (cartForm) {
    cartForm.addEventListener("change", function (e) {
      if (e.target && e.target.matches("input[name='updates[]']")) {
        cartForm.requestSubmit ? cartForm.requestSubmit() : cartForm.submit();
      }
    });
  }
})();
